import React from 'react';
import { Box } from '@wds/box';
import { createURL } from '@sm/utils';
import { generateMetricsAttribute } from '@sm/metrics';
import { UK_PATH_LINKS } from '../constants';
import { getSrc } from '~app/helpers/assetLoading';
import dareToAskUS from '~static/images/dareToAsk/dare-to-ask-us.gif';
import dareToAskUK from '~static/images/dareToAsk/dare-to-ask-uk.gif';
import curiosityConEp from '~static/images/dareToAsk/curiosity-con.webm';
import { SplitHeroImageProps } from '~helpers/types';

const SplitHeroImage = ({
  imageVariant,
  imageAlt,
  mobileImageVariant,
  classes,
  curiosityCon = false,
  ...metricsProps
}: SplitHeroImageProps): React.ReactElement => {
  const { utSource, utSource2, utSource3, amplitudeEvent, surveyId, collectorId, respondentId } = metricsProps;

  const isDareToAsk = imageVariant === dareToAskUS || imageVariant === dareToAskUK;
  const isRebrandEP2025 = utSource2 === 'rebrandEP2025';

  const renderDareToAskImage = (): JSX.Element => (
    <a
      href={createURL(
        imageVariant === dareToAskUK ? UK_PATH_LINKS?.exploreUkCtaUrl : '/mp/workplace-trends-for-a-new-era/',
        {
          ut_source: utSource,
          ut_source2: utSource2,
          ut_source3: utSource3,
          ut_ctatext: 'animated gif',
        }
      )}
      data-sm-metrics={generateMetricsAttribute({
        data: {
          amplitudeEvent,
          itemSelected: 'animated gif',
          surveyId,
          collectorId,
          respondentId,
          log: { message: `${utSource}-${utSource2}-${utSource3}` },
        },
      })}
    >
      <img src={getSrc(imageVariant)} alt={imageAlt} className={classes.imagePlacement} />
    </a>
  );

  const renderRebrandEP2025Images = (): JSX.Element => (
    <>
      <img src={getSrc(imageVariant)} alt={imageAlt} className={`${classes.imagePlacement} ${classes.imageDesktop}`} />
      <img
        src={getSrc(mobileImageVariant)}
        alt={imageAlt}
        className={`${classes.imagePlacement} ${classes.imageMobile}`}
      />
    </>
  );

  const renderCuriosityConVideo = (): JSX.Element => (
    <video
      src={curiosityConEp}
      className={classes.videoPlacement}
      autoPlay
      muted
      loop
      playsInline
      aria-label={imageAlt}
    />
  );

  const renderDefaultImage = (): JSX.Element => (
    <img src={getSrc(imageVariant)} alt={imageAlt} className={classes.imagePlacement} />
  );

  return (
    <Box display="grid" mb={8} className={curiosityCon ? classes.videoContainer : classes.resGripTemplate}>
      <Box display="grid" placeItems="center" className={curiosityCon ? classes.videoBox : ''}>
        {curiosityCon && renderCuriosityConVideo()}
        {isDareToAsk && renderDareToAskImage()}
        {isRebrandEP2025 && renderRebrandEP2025Images()}
        {!isDareToAsk && !isRebrandEP2025 && !curiosityCon && renderDefaultImage()}
      </Box>
    </Box>
  );
};

export default SplitHeroImage;
